import { message } from 'antd';
import { takeLatest, put } from 'redux-saga/effects';
import { TemplateObjectType, TemplatesAPI, TemplateState } from 'data/templates/api';
import { logger } from 'services';
import { createDocumentTemplateHighlightTaskAction } from '../../actions';
import { createDocumentTemplateHighlightTask } from '../../slices';
import { saveDocumentTemplate } from '../_save-template';
function* createDocumentTemplateHighlightTaskSaga(action) {
    const { payload: { task, docId, resourceSectionId, sectionId } } = action;
    try {
        const _taskTemplate = {
            templateId: 'new',
            templateName: task.taskName,
            templateContent: {
                private: false,
                ...task
            },
            objectType: TemplateObjectType.Task,
            state: TemplateState.Published
        };
        const taskTemplate = yield TemplatesAPI.save(_taskTemplate);
        yield put(createDocumentTemplateHighlightTask({
            docId,
            resourceSectionId,
            sectionId,
            task: {
                ...taskTemplate.templateContent,
                taskId: taskTemplate.templateId
            }
        }));
        yield saveDocumentTemplate(docId);
    } catch (error) {
        logger.error('an error creating a task on the highlighted text', {
            error
        });
        message.error('There was an error creating a task on the highlighted text');
    }
}
export const watchCreateDocumentTemplateHighlightTaskSaga = function*() {
    yield takeLatest(createDocumentTemplateHighlightTaskAction.type, createDocumentTemplateHighlightTaskSaga);
};
